import { Component, Inject } from '@angular/core';
import { TicketDto } from '../../../../../service/dto';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Router } from '@angular/router';

@Component({
	selector: 'app-ticket-picker',
	standalone: false,
	templateUrl: './ticket-picker.component.html',
	styleUrl: './ticket-picker.component.scss'
})
export class TicketPickerComponent {
	tickets: TicketDto[];

	constructor(@Inject(NZ_MODAL_DATA) data: TicketDto[], private modalRef: NzModalRef,private router: Router) {
		this.tickets = data;
	}

	open(ticket: any): void {
		this.modalRef.close();
		this.router.navigate(['/ticket', 'view', ticket.id]);
	}
}
